import { routes } from "constants/routes";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useSearchParams } from "react-router-dom";
import { RootState } from "store";

export default function PublicRoute() {
  const { userToken } = useSelector((state: RootState) => state.authState);
  const [params] = useSearchParams();
  const nextUrl = userToken && params.get("next") ? params.get("next") : "";
  const defaultUrl = userToken ? routes.HOME : routes.SIGNIN;

  if (!userToken) {
    return <Outlet />;
  } else {
    return <Navigate to={nextUrl || defaultUrl} replace />;
  }
}
